import { Progress } from 'antd';
import PropType from 'prop-types';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TIME_TYPE, UNIT_TYPE } from 'util/config/constant';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { translateHour } from 'util/translation/wordForm';
import { CleanedSquareValue } from 'components/UI/CleanedSquareValue';

export const VisualizationCleanedAreas = memo(
  ({ item, totalValue, unit, filterBy }) => {
    const { t } = useTranslation(TRANSLATION_NAMESPACES.CLEANING_REPORT);
    const {
      name,
      hours,
      isoWeek,
      cleanedSquareMeter,
      endDateOfWeek,
      startDateOfWeek
    } = item || {};

    const labelName = useMemo(() => {
      switch (filterBy) {
        case TIME_TYPE.Year:
          return t(`machineUtilisationPanel.monthNames.${name}`);

        case TIME_TYPE.Month:
          return t(`machineUtilisationPanel.numOfWeek`, { numOfWeek: isoWeek });

        case TIME_TYPE.Week:
          return t(`machineUtilisationPanel.dayNames.${name}`);

        default:
          return '';
      }
    }, [filterBy, isoWeek, name, t]);

    const itemPercent = useMemo(() => {
      return (
        ((unit === UNIT_TYPE.hours ? hours : cleanedSquareMeter) / totalValue) *
        100
      );
    }, [cleanedSquareMeter, hours, totalValue, unit]);

    return (
      <div className="visualization-clean-area" data-testid={name}>
        <div className="visualization-clean-area_header">
          <div>
            <span className="name">{labelName}</span>&nbsp;
            {startDateOfWeek && endDateOfWeek && (
              <span className="date">
                {startDateOfWeek} - {endDateOfWeek}
              </span>
            )}
          </div>
          <span className="unit">
            {unit === UNIT_TYPE.hours ? (
              translateHour(t, hours)
            ) : (
              <CleanedSquareValue cleanedSquareMeter={cleanedSquareMeter} />
            )}
          </span>
        </div>
        <div className="visualization-clean-area_progress">
          <Progress percent={itemPercent} showInfo={false} />
        </div>
      </div>
    );
  }
);

VisualizationCleanedAreas.propTypes = {
  item: PropType.shape().isRequired,
  totalValue: PropType.number.isRequired,
  unit: PropType.string.isRequired,
  filterBy: PropType.string.isRequired
};
